<template>
  <div class="mid_scroll_content depositWithdrawalPage">
    <section class="blockElement border-0">
      <div class="row justify-content-between mb-3 mb-md-5">
        <div class="col-12 col-md-5">
          <div class="card-body box-shadow h-100 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="blockDiv">
                <p class="mb-2">{{get_user.lead_type == 0 ? 'Individual Account' : 'Business Account'}}</p>
                <h3 class="semibold themecolor">
                  {{ get_user.profile.firstname }}
                  {{ get_user.profile.lastname }}
                </h3>
              </div>
              <div class="blockDiv">
                <p class="mb-2">Holding Value</p>
                <h3 class="semibold secondary">
                  ${{ totalBtcValue }}
                </h3>
              </div>
            </div>
            <router-link to="wallets" class="secondary semibold link"
              >Wallet Overview ></router-link
            >
          </div>
        </div>
        <div class="col-12 col-md-5">
          <div class="card-body box-shadow h-100">
            <div
              class="blockDiv d-flex align-items-center justify-content-between border-bottom mb-2 pb-2"
            >
              <h5 class="semibold themecolor">
                Funding Limits<!--  (USD) -->:
                <span
                  class="status f-14"
                  :class="
                    [1].includes(parseInt(get_user.tier))
                      ? 'redBG'
                      : [2, 3].includes(parseInt(get_user.tier))
                      ? 'yellowBG'
                      : [4, 5].includes(parseInt(get_user.tier))
                      ? 'greenBG'
                      : ''
                  "
                >
                  {{
                    [1].includes(parseInt(get_user.tier))
                      ? "Tier 1"
                      : [2, 3].includes(parseInt(get_user.tier))
                      ? "Tier 2"
                      : [4, 5].includes(parseInt(get_user.tier))
                      ? "Tier 3"
                      : ""
                  }}
                </span>
              </h5>
              <span class="borderBG f-14 status">In USD</span>
            </div>
            <div v-if="parseInt(get_user.tier) == 1">
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between">
                Crypto Deposits
                <span class="themecolor medium"> $10k/ account </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Crypto Withdrawals
                <span class="themecolor medium"> $1k/ account </span>
              </p>
            </div>
            <div v-else-if="parseInt(get_user.tier) == 2 || parseInt(get_user.tier) == 3">
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between">
                Crypto Deposits
                <span class="themecolor medium"> $500k/ account </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Crypto Withdrawals
                <span class="themecolor medium"> $10k/ day </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Fiat Deposits
                <span class="themecolor medium"> $10k/ day & $100k/ month </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Fiat Withdrawals
                <span class="themecolor medium"> $10k/ day & $100k/ month </span>
              </p>
            </div>
            <div v-else-if="parseInt(get_user.tier) == 4 || parseInt(get_user.tier) == 5">
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between">
                Crypto Deposits
                <span class="themecolor medium"> Unlimited </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Crypto Withdrawals
                <span class="themecolor medium"> $500k/ day </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Fiat Deposits
                <span class="themecolor medium"> $500k/ day </span>
              </p>
              <p class="f-15 border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between" >
                Fiat Withdrawals
                <span class="themecolor medium"> $500k/ day </span>
              </p>
            </div>
            <a
              href="javascript:void(0)"
              class="secondary semibold link mt-2 d-inline-flex"
              >Wallet Overview ></a
            >
          </div>
        </div>
      </div>
      <div class="row mb-3 mb-md-5">
        <div class="col-12 text-center">
          <ul
            class="d-inline-flex align-items-center justify-content-center customTabs border mx-auto my-md-5"
          >
            <li>
              <a
                @click="taskTab = 'Deposit'"
                :class="taskTab == 'Deposit' ? 'cap_btn active' : 'bg-white'"
                class="cap_btn border-0"
                href="javascript:void(0)"
                >Deposit</a
              >
            </li>
            <li>
              <a
                @click="taskTab = 'Withdrawal'"
                :class="taskTab == 'Withdrawal' ? 'cap_btn active' : 'bg-white'"
                class="cap_btn border-0"
                href="javascript:void(0)"
                >Withdrawal</a
              >
            </li>
          </ul>
        </div>
        <depositSection v-if="taskTab == 'Deposit'" />
        <withdrawalSection v-if="taskTab == 'Withdrawal'" />
      </div>
    </section>
  </div>
</template>
<script>
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import tradingMixins from "@/plugins/trading";
import depositSection from "./deposit";
import withdrawalSection from "./withdrawal";
export default {
  name: "deposit-withdrawal",
  mixins: [tradingMixins],
  data() {
    return {
      taskTab: "Deposit",
      pageLoader: false,
    };
  },
  components: {
    depositSection,
    withdrawalSection,
  },
  computed: {
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return [];
      }
    },
    totalBtcValue() {
      try {
        let amount = 0;
        for (const item in this.marginInfoList) {
          amount += parseFloat(
            this.getConvertedValue(this.marginInfoList[item], "USD")
          );
        }
        return amount.toFixed(3);
      } catch (e) {
        console.log(e);
        return "N/A";
      }
    },
  },
  methods: {
    formatfloat(num) {
      if (num) {
        num = parseFloat(num);
        try {
          return math.format(num, { notation: "fixed" }) || "";
        } catch (e) {
          try {
            return num.toFixed(8);
          } catch (e) {
            return "";
          }
        }
      } else {
        return 0;
      }
    },
    getConvertedValue(item, currency) {
      if (item.currency == currency) {
        return item.amount;
      } else {
        let amount = 0;
        if (this.instruments[item.currency + "-" + currency]) {
          amount = this.instruments[item.currency + "-" + currency].A;
        } else if (this.instruments[currency + "-" + item.currency]) {
          return 1 / this.instruments[currency + "-" + item.currency].A;
        } else {
          let basePrice = null,
            reversebasePrice = null,
            pairValue = null,
            revpairValue = null;
          if (currency == "USD") {
            basePrice = this.instruments[item.currency + "-BTC"];
            reversebasePrice = this.instruments["BTC-" + item.currency];
            pairValue = this.instruments["BTC-" + currency];
          } else {
            basePrice = this.instruments[item.currency + "-USD"];
            reversebasePrice = this.instruments["USD-" + item.currency];
            pairValue = this.instruments["USD-" + currency];
          }
          if (basePrice && pairValue) {
            amount = pairValue.A * basePrice.A;
          } else if (reversebasePrice && pairValue) {
            amount = pairValue.A / reversebasePrice.A;
          } else {
            amount = 0;
          }
        }
        if (currency == "USD") {
          return (amount * item.amount).toFixed(3);
          // return (amount * item.amount).toFixed(3)
        } else {
          return this.formatfloat(amount * item.amount);
        }
      }
    },
  },
  created() {
    
    this.pageName("Deposit Withdrawal");
    if (this.$route.query.deposit) {
      this.taskTab = "Deposit";
    } else if (this.$route.query.withdraw) {
      this.taskTab = "Withdrawal";
    }
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/index.vue